const CONTACT_LIMITS = { fullName: 120, email: 254, phoneNumber: 40, subject: 160, message: 8000 };
const CONTACT_INITIAL = { fullName: '', email: '', phoneNumber: '', subject: 'General enquiry', message: '', website: '' };
function normalizeContact(input = {}) {
  return Object.fromEntries(Object.keys(CONTACT_INITIAL).map(key =>
    [key, typeof input[key] === 'string' ? input[key].trim() : '']));
}
function validateContact(input) {
  const values = normalizeContact(input);
  const errors = {};
  for (const key of ['fullName', 'email', 'subject', 'message']) {
    if (!values[key]) errors[key] = ({fullName:'Enter your name.',email:'Enter your email.',subject:'Choose a topic.',message:'Enter your message.'})[key];
  }
  if (values.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(values.email)) errors.email = 'Enter a valid email address.';
  for (const [key, max] of Object.entries(CONTACT_LIMITS)) {
    if (values[key].length > max) errors[key] = 'Use no more than ' + max + ' characters.';
  }
  return errors;
}
module.exports = { CONTACT_LIMITS, CONTACT_INITIAL, normalizeContact, validateContact };

